import { defineManifest } from '@ndrc/app-sdk/manifest';
import { emitsOf } from '@ndrc/app-sdk/events';
import { events } from './events.js';
import fr from './messages/fr.json' with { type: 'json' };
export const manifest = defineManifest({
  id: 'social_studio',
  name: fr.title,
  description: fr.description,
  icon: 'grid',
  color: '#6D28D9',
  glyph: [{ d: 'M4 4h16v12H9l-5 4z' }, { d: 'M8 8h8M8 12h5' }],
  version: '0.1.0',
  sdk: '0.0.0',
  status: 'dev',
  category: 'relation-client',
  permissions: {
    uses: ['app.records.read', 'app.records.write', 'files.images.read', 'files.images.write'],
    defines: [],
  },
  entities: {
    uses: [],
    owns: ['posts', 'comments', 'history', 'receipts', 'referrals', 'response_proposals'].map(
      (table) => ({
        table,
        scope: 'workspace' as const,
        description: fr.description,
      }),
    ),
  },
  events: {
    emits: emitsOf(events),
    subscribes: [
      { type: 'social_studio.post.due', handler: 'onPostDue' },
      { type: 'reputation.response.proposed', handler: 'onResponseProposed' },
    ],
  },
  ui: {
    student: { defaultRoute: '/', routes: [{ path: '/', title: fr.title }], layout: 'full' },
    teacher: { panel: true, widgets: [], studentInspector: true },
  },
  missions: {
    actions: ['social_studio.seed'],
    conditions: ['social_studio.completed'],
    blocks: [],
  },
  migrations: { schema: 'app_social_studio', dir: 'migrations' },
});
